module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/our-process.json
// module id = 374
// module chunks = 5056972015393